// // components/Navbar.jsx
// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { motion } from 'framer-motion';
// import { useAuth } from '../context/AuthContext';

// const Navbar = () => {
//   const { currentUser, userDetails, signOut } = useAuth();
//   const navigate = useNavigate();
//   const [isOpen, setIsOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const [showUserDropdown, setShowUserDropdown] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       const offset = window.scrollY;
//       if (offset > 50) {
//         setScrolled(true);
//       } else {
//         setScrolled(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => {
//       window.removeEventListener('scroll', handleScroll);
//     };
//   }, []);

//   const handleSignOut = async () => {
//     try {
//       await signOut();
//       navigate('/');
//       setShowUserDropdown(false);
//     } catch (error) {
//       console.error('Error signing out:', error);
//     }
//   };

//   // Close dropdowns when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (showUserDropdown && !event.target.closest('.user-dropdown')) {
//         setShowUserDropdown(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [showUserDropdown]);

//   // Top navigation items
//   const topNavLinks = [
//     // { name: 'Online Classes', path: '/master-classes' },
//   ];

//   // Main navigation items
//   const mainNavLinks = [
//     { name: 'Programs', path: '/classroom'},
//     { name: 'Online Classes', path: '/master-classes'},
//     { name: 'Test Series', path: '/test-series'},
//     { name: 'Mentoring', path: '/mentoring'},
//     { name: 'Smart Content', path: '/smart-content' },
//     { name: 'Blog', path: '/blog' }
//   ];

//   return (
//     <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'shadow-lg' : ''}`}>
//       {/* Top Contact Bar */}
//       <div className="hidden lg:block bg-[#2C5282] text-white">
//         <div className="max-w-7xl mx-auto px-4 py-1.5 flex justify-between items-center">
//           <div className="flex items-center text-sm">
//             <span className="font-medium"></span>
//           </div>
//           <div className="flex items-center">
//             {topNavLinks.map((link) => (
//               <div key={link.name} className="relative text-sm px-3">
//                 <Link
//                   to={link.path}
//                   className="text-white hover:text-blue-200 transition-colors whitespace-nowrap flex items-center font-medium"
//                 >
//                   {link.name}
//                   {link.hasDropdown && (
//                     <svg className="ml-1 w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                     </svg>
//                   )}
//                   {link.isNew && (
//                     <span className="ml-1 px-1.5 py-0.5 text-xs font-medium rounded bg-white text-[#2C5282]">
//                       NEW
//                     </span>
//                   )}
//                 </Link>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Main Navigation Bar */}
//       <div className={`bg-white ${scrolled ? 'py-2' : 'py-3'} transition-all duration-300 ${scrolled ? 'shadow-md' : 'border-b border-gray-100'}`}>
//         <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
//           {/* Logo Section */}
//           <Link to="/" className="flex items-center">
//             <img
//               className="h-14 w-auto"
//               src={require('../assets/logo.png')}
//               alt="SKYSEP"
//             />
//             <span className="ml-2 text-xl font-bold text-[#2C5282]">SKYSEP</span>
//           </Link>

//           {/* Desktop Navigation - Right */}
//           <div className="hidden lg:flex items-center space-x-6">
//             {mainNavLinks.map((link) => (
//               <div key={link.name} className="group relative">
//                 <Link
//                   to={link.path}
//                   className="px-2 py-2 text-sm font-medium text-[#2C5282] hover:text-[#1A365D] transition-colors flex items-center"
//                 >
//                   {link.name}
//                   {link.hasDropdown && (
//                     <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                     </svg>
//                   )}
//                 </Link>
//                 {/* Dropdown container for future expansion */}
//                 {link.hasDropdown && (
//                   <div className="hidden group-hover:block absolute left-0 pt-2 w-48 z-50">
//                     <div className="bg-white border border-gray-200 rounded-lg shadow-lg py-1">
//                       {/* Dropdown items would go here */}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ))}

//             {/* Authentication Links or User Profile */}
//             {currentUser ? (
//               <div className="relative user-dropdown ml-4">
//                 <button
//                   onClick={() => setShowUserDropdown(!showUserDropdown)}
//                   className="flex items-center space-x-2 text-[#2C5282] hover:text-[#1A365D] transition-colors focus:outline-none"
//                 >
//                   {userDetails?.photoURL ? (
//                     <img 
//                       src={userDetails.photoURL} 
//                       alt="Profile" 
//                       className="h-8 w-8 rounded-full border-2 border-[#2C5282]"
//                     />
//                   ) : (
//                     <div className="h-8 w-8 rounded-full bg-[#2C5282] flex items-center justify-center text-white font-medium">
//                       {userDetails?.firstName?.charAt(0) || currentUser?.email?.charAt(0)?.toUpperCase() || 'U'}
//                     </div>
//                   )}
//                   <span className="text-sm font-medium">
//                     {userDetails?.firstName || currentUser?.email?.split('@')[0]}
//                   </span>
//                   <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//                   </svg>
//                 </button>
                
//                 {/* User Dropdown Menu */}
//                 {showUserDropdown && (
//                   <motion.div 
//                     initial={{ opacity: 0, y: -10 }}
//                     animate={{ opacity: 1, y: 0 }}
//                     exit={{ opacity: 0, y: -10 }}
//                     className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 border border-gray-100 z-50"
//                   >
                    
//                     <Link
//                       to="/profile"
//                       className="block px-4 py-2 text-sm text-[#2C5282] hover:bg-blue-50 transition-colors"
//                       onClick={() => setShowUserDropdown(false)}
//                     >
//                       My Profile
//                     </Link>
                   
//                     <div className="border-t border-gray-100 my-1"></div>
//                     <button
//                       onClick={handleSignOut}
//                       className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
//                     >
//                       Sign Out
//                     </button>
//                   </motion.div>
//                 )}
//               </div>
//             ) : (
//               <div className="flex items-center ml-4 space-x-3">
//                 <Link
//                   to="/register"
//                   className="px-4 py-2 text-sm font-medium bg-[#2C5282] text-white hover:bg-[#1A365D] rounded-md transition-colors shadow-sm"
//                 >
//                   Register
//                 </Link>
//                 <Link
//                   to="/login"
//                   className="px-4 py-2 text-sm font-medium text-[#2C5282] hover:text-[#1A365D] border border-[#2C5282] rounded-md transition-colors"
//                 >
//                   Login
//                 </Link>
//               </div>
//             )}
//           </div>

//           {/* Mobile Menu Button */}
//           <div className="lg:hidden">
//             <button
//               onClick={() => setIsOpen(!isOpen)}
//               className="p-2 text-[#2C5282] focus:outline-none"
//             >
//               <span className="sr-only">Open menu</span>
//               {isOpen ? (
//                 <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               ) : (
//                 <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
//                 </svg>
//               )}
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       <motion.div 
//         initial={false}
//         animate={{ height: isOpen ? 'auto' : 0 }}
//         className={`lg:hidden bg-white shadow-xl overflow-hidden`}
//       >
//         <div className="px-4 py-3 space-y-2">
//           {/* User Profile - Mobile */}
//           {currentUser && (
//             <div className="mb-4">
//               <div className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg">
//                 {userDetails?.photoURL ? (
//                   <img 
//                     src={userDetails.photoURL} 
//                     alt="Profile" 
//                     className="h-10 w-10 rounded-full border-2 border-[#2C5282]"
//                   />
//                 ) : (
//                   <div className="h-10 w-10 rounded-full bg-[#2C5282] flex items-center justify-center text-white text-lg font-medium">
//                     {userDetails?.firstName?.charAt(0) || currentUser?.email?.charAt(0)?.toUpperCase() || 'U'}
//                   </div>
//                 )}
//                 <div>
//                   <div className="text-[#2C5282] font-medium">
//                     {userDetails?.firstName ? `${userDetails.firstName} ${userDetails.lastName}` : currentUser?.email?.split('@')[0]}
//                   </div>
//                   <div className="text-[#1A365D] text-sm">{currentUser.email}</div>
//                 </div>
//               </div>
              
//               {/* User Menu - Mobile */}
//               <div className="mt-3 space-y-1">
                
//                 <Link
//                   to="/profile"
//                   className="block px-3 py-2 text-[#2C5282] hover:bg-blue-50 rounded-md transition-colors"
//                   onClick={() => setIsOpen(false)}
//                 >
//                   My Profile
//                 </Link>
               
//               </div>
//             </div>
//           )}
          
//           {/* Divider */}
//           <div className="border-t border-gray-200 my-3"></div>
          
//           {/* Main Navigation Items - Mobile */}
//           {[...mainNavLinks, ...topNavLinks].map((link) => (
//             <Link
//               key={link.name}
//               to={link.path}
//               className="block py-2 text-base text-[#2C5282] hover:text-[#1A365D] flex justify-between items-center"
//               onClick={() => setIsOpen(false)}
//             >
//               <span>{link.name}</span>
//               {link.isNew && (
//                 <span className="px-1.5 py-0.5 text-xs rounded bg-blue-100 text-[#2C5282] font-medium">
//                   NEW
//                 </span>
//               )}
//             </Link>
//           ))}
          
//           {/* Authentication Links - Mobile */}
//           {!currentUser ? (
//             <>
//               <div className="border-t border-gray-200 my-3"></div>
//               <div className="flex flex-col space-y-2 pt-2">
//                 <Link
//                   to="/register"
//                   className="block py-2 text-center text-base bg-[#2C5282] text-white hover:bg-[#1A365D] rounded-md transition-colors"
//                   onClick={() => setIsOpen(false)}
//                 >
//                   Register
//                 </Link>
//                 <Link
//                   to="/login"
//                   className="block py-2 text-center text-base text-[#2C5282] hover:text-[#1A365D] border border-[#2C5282] rounded-md transition-colors"
//                   onClick={() => setIsOpen(false)}
//                 >
//                   Login
//                 </Link>
//               </div>
//             </>
//           ) : (
//             <>
//               <div className="border-t border-gray-200 my-3"></div>
//               <button
//                 onClick={handleSignOut}
//                 className="w-full py-2 text-center text-base text-red-600 hover:bg-red-50 rounded-md transition-colors"
//               >
//                 Sign Out
//               </button>
//             </>
//           )}
//         </div>
//       </motion.div>
//     </nav>
//   );
// };

// export default Navbar;
// components/Navbar.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom'; // Add useLocation
import { motion } from 'framer-motion';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const { currentUser, userDetails, signOut } = useAuth();
  const navigate = useNavigate();
  const location = useLocation(); // Add this to get current path
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [showUserDropdown, setShowUserDropdown] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/');
      setShowUserDropdown(false);
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserDropdown && !event.target.closest('.user-dropdown')) {
        setShowUserDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showUserDropdown]);

  // Function to check if link is active
  const isActiveLink = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  // Top navigation items
  const topNavLinks = [
    // { name: 'Online Classes', path: '/master-classes' },
  ];

  // Main navigation items
  const mainNavLinks = [
    { name: 'Programs', path: '/classroom'},
    { name: 'Online Classes', path: '/master-classes'},
    { name: 'Test Series', path: '/test-series'},
    { name: 'Mentoring', path: '/mentoring'},
    { name: 'Smart Content', path: '/smart-content' },
    { name: 'Blog', path: '/blog' }
  ];

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'shadow-lg' : ''}`}>
      {/* Top Contact Bar */}
      <div className="hidden lg:block bg-[#2C5282] text-white">
        <div className="max-w-7xl mx-auto px-4 py-1.5 flex justify-between items-center">
          <div className="flex items-center text-sm">
            <span className="font-medium"></span>
          </div>
          <div className="flex items-center">
            {topNavLinks.map((link) => (
              <div key={link.name} className="relative text-sm px-3">
                <Link
                  to={link.path}
                  className={`transition-colors whitespace-nowrap flex items-center font-medium ${
                    isActiveLink(link.path)
                      ? 'text-blue-200 border-b-2 border-blue-200 pb-1'
                      : 'text-white hover:text-blue-200'
                  }`}
                >
                  {link.name}
                  {link.hasDropdown && (
                    <svg className="ml-1 w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                  {link.isNew && (
                    <span className="ml-1 px-1.5 py-0.5 text-xs font-medium rounded bg-white text-[#2C5282]">
                      NEW
                    </span>
                  )}
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Navigation Bar */}
      <div className={`bg-white ${scrolled ? 'py-2' : 'py-3'} transition-all duration-300 ${scrolled ? 'shadow-md' : 'border-b border-gray-100'}`}>
        <div className="max-w-7xl mx-auto px-4 flex justify-between items-center">
          {/* Logo Section */}
          <Link to="/" className="flex items-center">
            <img
              className="h-14 w-auto"
              src={require('../assets/logo.png')}
              alt="SKYSEP"
            />
            <span className="ml-2 text-xl font-bold text-[#2C5282]">SKYSEP</span>
          </Link>

          {/* Desktop Navigation - Right */}
          <div className="hidden lg:flex items-center space-x-6">
            {mainNavLinks.map((link) => (
              <div key={link.name} className="group relative">
                <Link
                  to={link.path}
                  className={`px-2 py-2 text-sm font-medium transition-colors flex items-center relative ${
                    isActiveLink(link.path)
                      ? 'text-[#1A365D] font-semibold'
                      : 'text-[#2C5282] hover:text-[#1A365D]'
                  }`}
                >
                  {link.name}
                  {link.hasDropdown && (
                    <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                    </svg>
                  )}
                  {/* Active indicator - underline */}
                  {isActiveLink(link.path) && (
                    <motion.div
                      layoutId="activeTab"
                      className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#2C5282]"
                      initial={false}
                      transition={{ type: "spring", stiffness: 300, damping: 30 }}
                    />
                  )}
                </Link>
                {/* Dropdown container for future expansion */}
                {link.hasDropdown && (
                  <div className="hidden group-hover:block absolute left-0 pt-2 w-48 z-50">
                    <div className="bg-white border border-gray-200 rounded-lg shadow-lg py-1">
                      {/* Dropdown items would go here */}
                    </div>
                  </div>
                )}
              </div>
            ))}

            {/* Authentication Links or User Profile */}
            {currentUser ? (
              <div className="relative user-dropdown ml-4">
                <button
                  onClick={() => setShowUserDropdown(!showUserDropdown)}
                  className="flex items-center space-x-2 text-[#2C5282] hover:text-[#1A365D] transition-colors focus:outline-none"
                >
                  {userDetails?.photoURL ? (
                    <img 
                      src={userDetails.photoURL} 
                      alt="Profile" 
                      className="h-8 w-8 rounded-full border-2 border-[#2C5282]"
                    />
                  ) : (
                    <div className="h-8 w-8 rounded-full bg-[#2C5282] flex items-center justify-center text-white font-medium">
                      {userDetails?.firstName?.charAt(0) || currentUser?.email?.charAt(0)?.toUpperCase() || 'U'}
                    </div>
                  )}
                  <span className="text-sm font-medium">
                    {userDetails?.firstName || currentUser?.email?.split('@')[0]}
                  </span>
                  <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {/* User Dropdown Menu */}
                {showUserDropdown && (
                  <motion.div 
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-1 border border-gray-100 z-50"
                  >
                    
                    <Link
                      to="/profile"
                      className={`block px-4 py-2 text-sm transition-colors ${
                        isActiveLink('/profile')
                          ? 'text-[#1A365D] bg-blue-50 font-medium'
                          : 'text-[#2C5282] hover:bg-blue-50'
                      }`}
                      onClick={() => setShowUserDropdown(false)}
                    >
                      My Profile
                    </Link>
                   
                    <div className="border-t border-gray-100 my-1"></div>
                    <button
                      onClick={handleSignOut}
                      className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors"
                    >
                      Sign Out
                    </button>
                  </motion.div>
                )}
              </div>
            ) : (
              <div className="flex items-center ml-4 space-x-3">
                <Link
                  to="/register"
                  className="px-4 py-2 text-sm font-medium bg-[#2C5282] text-white hover:bg-[#1A365D] rounded-md transition-colors shadow-sm"
                >
                  Register
                </Link>
                <Link
                  to="/login"
                  className="px-4 py-2 text-sm font-medium text-[#2C5282] hover:text-[#1A365D] border border-[#2C5282] rounded-md transition-colors"
                >
                  Login
                </Link>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 text-[#2C5282] focus:outline-none"
            >
              <span className="sr-only">Open menu</span>
              {isOpen ? (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <motion.div 
        initial={false}
        animate={{ height: isOpen ? 'auto' : 0 }}
        className={`lg:hidden bg-white shadow-xl overflow-hidden`}
      >
        <div className="px-4 py-3 space-y-2">
          {/* User Profile - Mobile */}
          {currentUser && (
            <div className="mb-4">
              <div className="flex items-center space-x-3 p-3 bg-blue-50 rounded-lg">
                {userDetails?.photoURL ? (
                  <img 
                    src={userDetails.photoURL} 
                    alt="Profile" 
                    className="h-10 w-10 rounded-full border-2 border-[#2C5282]"
                  />
                ) : (
                  <div className="h-10 w-10 rounded-full bg-[#2C5282] flex items-center justify-center text-white text-lg font-medium">
                    {userDetails?.firstName?.charAt(0) || currentUser?.email?.charAt(0)?.toUpperCase() || 'U'}
                  </div>
                )}
                <div>
                  <div className="text-[#2C5282] font-medium">
                    {userDetails?.firstName ? `${userDetails.firstName} ${userDetails.lastName}` : currentUser?.email?.split('@')[0]}
                  </div>
                  <div className="text-[#1A365D] text-sm">{currentUser.email}</div>
                </div>
              </div>
              
              {/* User Menu - Mobile */}
              <div className="mt-3 space-y-1">
                
                <Link
                  to="/profile"
                  className={`block px-3 py-2 rounded-md transition-colors ${
                    isActiveLink('/profile')
                      ? 'text-[#1A365D] bg-blue-100 font-medium border-l-4 border-[#2C5282]'
                      : 'text-[#2C5282] hover:bg-blue-50'
                  }`}
                  onClick={() => setIsOpen(false)}
                >
                  My Profile
                </Link>
               
              </div>
            </div>
          )}
          
          {/* Divider */}
          <div className="border-t border-gray-200 my-3"></div>
          
          {/* Main Navigation Items - Mobile */}
          {[...mainNavLinks, ...topNavLinks].map((link) => (
            <Link
              key={link.name}
              to={link.path}
              className={`block py-2 text-base flex justify-between items-center rounded-md px-3 transition-colors ${
                isActiveLink(link.path)
                  ? 'text-[#1A365D] font-semibold bg-blue-50 border-l-4 border-[#2C5282]'
                  : 'text-[#2C5282] hover:text-[#1A365D] hover:bg-blue-50'
              }`}
              onClick={() => setIsOpen(false)}
            >
              <span>{link.name}</span>
              {link.isNew && (
                <span className="px-1.5 py-0.5 text-xs rounded bg-blue-100 text-[#2C5282] font-medium">
                  NEW
                </span>
              )}
            </Link>
          ))}
          
          {/* Authentication Links - Mobile */}
          {!currentUser ? (
            <>
              <div className="border-t border-gray-200 my-3"></div>
              <div className="flex flex-col space-y-2 pt-2">
                <Link
                  to="/register"
                  className="block py-2 text-center text-base bg-[#2C5282] text-white hover:bg-[#1A365D] rounded-md transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Register
                </Link>
                <Link
                  to="/login"
                  className="block py-2 text-center text-base text-[#2C5282] hover:text-[#1A365D] border border-[#2C5282] rounded-md transition-colors"
                  onClick={() => setIsOpen(false)}
                >
                  Login
                </Link>
              </div>
            </>
          ) : (
            <>
              <div className="border-t border-gray-200 my-3"></div>
              <button
                onClick={handleSignOut}
                className="w-full py-2 text-center text-base text-red-600 hover:bg-red-50 rounded-md transition-colors"
              >
                Sign Out
              </button>
            </>
          )}
        </div>
      </motion.div>
    </nav>
  );
};

export default Navbar;